import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import type { ExtensionDefinition } from '@backstage/frontend-plugin-api';
import { isAdditionalInfoEntity } from './additional-info-card-filter';

export const entityCardAdditionalInfo: ExtensionDefinition =
  EntityCardBlueprint.make({
    name: 'additional-info-card',
    params: {
      type: 'info',
      filter: isAdditionalInfoEntity,
      loader: async () =>
        import('./additional-info-card').then(m => <m.AdditionalInfoCard />),
    },
  });
